import React, { useEffect, useState, createElement } from 'react';
import { UrgencyBar } from '../components/sales/UrgencyBar';
import { HeroSection } from '../components/sales/HeroSection';
import { LeadSection } from '../components/sales/LeadSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { WhatYouGet } from '../components/sales/WhatYouGet';
import { Testimonials } from '../components/sales/Testimonials';
import { PriceSection } from '../components/sales/PriceSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { FAQSection } from '../components/sales/FAQSection';
import { FinalCTA } from '../components/sales/FinalCTA';
import { Modal } from '../components/ui/Modal';
export function SalesPage() {
  const [showTerminos, setShowTerminos] = useState(false);
  const [showPrivacidad, setShowPrivacidad] = useState(false);
  useEffect(() => {
    // Set up fbq stub so calls queue before script loads
    const win = window as any;
    if (!win.fbq) {
      const fbq: any = function (...args: any[]) {
        fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
      };
      win.fbq = fbq;
      win._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
    }
    // Inject script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Fire events (queued until script loads)
    win.fbq('init', '662740706921819');
    win.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-252">
      <UrgencyBar data-id="element-253" />
      <HeroSection data-id="element-254" />
      <LeadSection data-id="element-255" />
      <ProblemSection data-id="element-256" />
      <MechanismSection data-id="element-257" />
      <WhatYouGet data-id="element-258" />
      <Testimonials data-id="element-259" />
      <PriceSection data-id="element-260" />
      <GuaranteeSection data-id="element-261" />
      <FAQSection data-id="element-262" />
      <FinalCTA data-id="element-263" />

      <footer className="bg-slate-950 text-slate-600 py-8 text-center text-sm" data-id="element-264">
        <div className="container mx-auto px-4" data-id="element-265">
          <p data-id="element-266">
            &copy; {new Date().getFullYear()} El Protocolo Sombrilla. Todos los
            derechos reservados.
          </p>
          <p className="mt-2" data-id="element-267">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
          <div className="mt-4 flex justify-center gap-4" data-id="element-268">
            <button onClick={() => setShowTerminos(true)} className="hover:text-slate-400 underline underline-offset-2 transition-colors" data-id="element-269">
              Términos
            </button>
            <button onClick={() => setShowPrivacidad(true)} className="hover:text-slate-400 underline underline-offset-2 transition-colors" data-id="element-270">
              Privacidad
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showTerminos} onClose={() => setShowTerminos(false)} title="Términos y Condiciones" data-id="element-271">
        <p data-id="element-272">
          <strong data-id="element-273">Última actualización:</strong> {new Date().getFullYear()}
        </p>
        <p data-id="element-274">
          Al adquirir El Protocolo Sombrilla, usted acepta los siguientes
          términos y condiciones de uso.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-275">
          1. Naturaleza del Producto
        </h3>
        <p data-id="element-276">
          El Protocolo Sombrilla es un producto de información digital
          educativa. No constituye asesoramiento legal, financiero ni
          migratorio.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-277">
          2. Uso Personal
        </h3>
        <p data-id="element-278">
          Este producto es para uso personal exclusivamente. Queda prohibida su
          reproducción, distribución o reventa sin autorización expresa por
          escrito.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-279">
          3. Garantía de Devolución
        </h3>
        <p data-id="element-280">
          Ofrecemos una garantía de satisfacción de 30 días. Si no está
          satisfecho, contáctenos dentro de los 30 días posteriores a su compra
          para solicitar un reembolso completo.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-281">
          4. Limitación de Responsabilidad
        </h3>
        <p data-id="element-282">
          Los creadores no se hacen responsables de decisiones tomadas basándose
          en la información aquí contenida. Siempre consulte con un profesional
          legal certificado.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-283">
          5. Modificaciones
        </h3>
        <p data-id="element-284">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento.
        </p>
      </Modal>

      <Modal isOpen={showPrivacidad} onClose={() => setShowPrivacidad(false)} title="Política de Privacidad" data-id="element-285">
        <p data-id="element-286">
          <strong data-id="element-287">Última actualización:</strong> {new Date().getFullYear()}
        </p>
        <p data-id="element-288">
          Su privacidad es importante para nosotros. Esta política explica cómo
          recopilamos y usamos su información.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-289">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-290">
          Recopilamos únicamente la información necesaria para procesar su
          compra: nombre, correo electrónico y datos de pago.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-291">
          2. Uso de la Información
        </h3>
        <p data-id="element-292">
          Su información se utiliza exclusivamente para entregar el producto
          adquirido y comunicaciones relacionadas con su compra.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-293">
          3. No Compartimos su Información
        </h3>
        <p data-id="element-294">
          No vendemos ni compartimos su información personal con terceros,
          excepto los procesadores de pago necesarios.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-295">
          4. Seguridad
        </h3>
        <p data-id="element-296">
          Utilizamos encriptación SSL de 256 bits para proteger toda la
          información transmitida en este sitio.
        </p>
        <h3 className="font-bold text-slate-800 text-base mt-4" data-id="element-297">
          5. Sus Derechos
        </h3>
        <p data-id="element-298">
          Usted tiene derecho a solicitar la eliminación de sus datos en
          cualquier momento contactándonos directamente.
        </p>
      </Modal>
    </div>;
}